import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

const useViaeroButtonStyles = makeStyles({
    viaeroButton: {
        ...shorthands.borderRadius(tokens.borderRadiusLarge),
        width: '100%'
    },
    startIcon: {
        marginRight: tokens.spacingHorizontalS
    },
    endIcon: {
        marginLeft: tokens.spacingHorizontalS
    }
});

export default useViaeroButtonStyles;
